// @core/api/endpoints/bootstrap/save_product_selection.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SaveProductSelectionRequest,
  SaveProductSelectionResponse,
} from '../../../types/bootstrap';

const BASE_PATH = '/bootstrap';

/**
 * Save product selection
 * Saves which products to enable. Core products (authn, authz, user, secret) are always included. Returns the resolved list with auto-enabled dependencies.
 * @public This endpoint does not require authentication
 */
export async function SaveProductSelection(
  data: SaveProductSelectionRequest,
  options?: RequestOptions
): Promise<SaveProductSelectionResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/setup/steps/products`;
  const requestOptions = { ...options, skipAuth: true };
  return client.put<SaveProductSelectionResponse>(requestPath, data, requestOptions);
}
